// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1_K1i","cls2":"AccountMenuButton-cls2_Wx7 AccountMenuButton-cls1_K1i"};